export default __webpack_public_path__ + "static/media/section-2-left-1.1d9cafe4.png";